<script>
    // @check-js
    export let active = true;
    import { onMount } from "svelte";
    let y = 0;
    let lastY = 0;
    const PIN_CLASS = "pin";
    const UNPIN_CLASS = "unpin";
    let headerClass = PIN_CLASS;
    const UP = "up";
    const DOWN = "down";
    let direction = UP;
    let origElement;
    let origElementHeight;

    onMount(() => {
        origElementHeight = origElement.offsetHeight;
    });

    function shouldShow(y, active) {
        // Always show if the hider isn't active
        if (!active) {
            return true;
        }
        // Don't hide when we're close to the top
        if (y < origElementHeight / 2) {
            return true;
        }
        let result = headerClass === PIN_CLASS;
        const scrolledPxs = lastY - y;
        const scrollDirection = scrolledPxs < 0 ? DOWN : UP;
        const changedDirection = scrollDirection !== direction;
        if (changedDirection) {
            result = scrollDirection === DOWN ? false : true;
        }
        direction = scrollDirection;
        lastY = y;
        return result;
    }

    $: if (shouldShow(y, active)) {
        headerClass = PIN_CLASS;
    } else {
        headerClass = UNPIN_CLASS;
    }
</script>

<svelte:window bind:scrollY={y} />
<div class={headerClass} bind:this={origElement}>
    <slot />
</div>

<style>
    div {
        height: var(--header-height);
        position: fixed;
        width: 100%;
        transition: all 0.3s linear;
        z-index: 11;
    }
    .pin {
        top: 0;
    }
    .unpin {
        top: calc(var(--header-height) * -1);
    }
</style>
